import { requireLegacy } from '../../legacy/legacyGlobals';

const asHtml = (html: string) => ({ __html: html });

declare global {
  interface Window {
    /** YouTube id for the recorded explainer; empty until it exists (env.js). */
    HOW_IT_WORKS_VIDEO?: string;
  }
}

const PLAY_IC = '<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9.2"/><path d="M10.2 8.6 15.4 12l-5.2 3.4z" fill="currentColor"/></svg>';

interface HowItWorksSheetProps {
  onClose: () => void;
  /** The closing call to action — same journey as the landing's primary button. */
  onJoin: () => void;
}

/**
 * The "How it works" explainer: the recorded video (once env.js carries its
 * id) above the written story and the four steps — fully translated, body
 * included (hw* keys in i18n-ext.js).
 */
export function HowItWorksSheet({ onClose, onJoin }: HowItWorksSheetProps) {
  const t = requireLegacy('t');
  const videoId = (window.HOW_IT_WORKS_VIDEO || '').trim();

  return (
    <div className="v2works" role="dialog" aria-modal="true" aria-label={t('howWorksT')}>
      <div className="v2works-dim" onClick={onClose} />
      <div className="v2works-card">
        <div className="v2works-head">
          <b>{t('howWorksT')}</b>
          <button className="v2works-close" aria-label={t('back')} onClick={onClose}>✕</button>
        </div>
        <div className="v2works-scroll">
          {videoId ? (
            <div className="v2works-video">
              <iframe
                src={'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?rel=0'}
                title={t('howWorksT')}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          ) : (
            <div className="v2works-video v2works-soon">
              <span dangerouslySetInnerHTML={asHtml(PLAY_IC)} />
              <small>{t('hwSoon')}</small>
            </div>
          )}
          <p dangerouslySetInnerHTML={asHtml(t('hwP1'))} />
          <p dangerouslySetInnerHTML={asHtml(t('hwP2'))} />
          <p dangerouslySetInnerHTML={asHtml(t('hwP3'))} />
          <b className="v2works-sub">{t('hwStepsH')}</b>
          <ol>
            <li>{t('hwS1')}</li>
            <li>{t('hwS2')}</li>
            <li>{t('hwS3')}</li>
            <li>{t('hwS4')}</li>
          </ol>
          <p dangerouslySetInnerHTML={asHtml(t('hwP4'))} />
          <p className="v2works-cta-line">{t('hwCta')}</p>
          <button className="lbtn primary v2works-join" onClick={onJoin}>{t('btnJoin')}</button>
        </div>
      </div>
    </div>
  );
}
